import React from 'react';
import isMobile from 'ismobilejs';

import Footer from './Footer';
import Screen1 from './Screen1';
import Screen2 from './Screen2';
import Screen3 from './Screen3';
import ScreenTransition from './ScreenTransition';
import Screen4 from './Screen4';
import Screen5 from './Screen5';
import ReportMessage from './ReportMessage';


export default ({location}) => {
  return (
    <div id="screens" class={isMobile().any ? 'is-mobile' : 'is-desktop'}>
      <Screen1/>
      <Screen2/>
      <ScreenTransition/>
      <Screen4/>
      <Screen5 location={location}/>
      <ReportMessage/>
      <Screen3/>
      <Footer/>
    </div>
  );
}
